export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5912.7400751b.jpg";